import Reveal, { Overline } from "./Reveal";
import { useLightbox } from "../lib/lightbox";

const slug = (s) =>
  String(s || "item").toLowerCase().replace(/[^a-z0-9]+/g, "-");

function AssetCard({ a, className = "" }) {
  const { open } = useLightbox();
  const img = a.images?.[0] || a.img;

  return (
    <div
      data-testid={`asset-card-${slug(a.id || a.title)}`}
      className={`group relative overflow-hidden border border-line ${className}`}
    >
      {img ? (
        <img
          src={img}
          alt={a.title}
          className="absolute inset-0 h-full w-full cursor-zoom-in object-cover transition-transform duration-700 ease-out group-hover:scale-105"
          onClick={() => open([img], 0)}
          data-testid="asset-image-open"
        />
      ) : (
        <div className="absolute inset-0 bg-surface" />
      )}
      <div className="pointer-events-none absolute inset-0 bg-gradient-to-t from-ink/90 via-ink/15 to-transparent" />
      <div className="absolute inset-x-0 bottom-0 p-6">
        {(a.specs || []).length > 0 && (
          <div className="flex flex-wrap gap-1.5">
            {a.specs.map((s, i) => (
              <span
                key={i}
                className="border border-white/25 bg-ink/60 px-2 py-1 font-mono text-[9px] uppercase tracking-[0.12em] text-slate-200 backdrop-blur-sm"
              >
                {s.k}: {s.v}
              </span>
            ))}
          </div>
        )}
        <h3 className="mt-3 font-display text-lg uppercase tracking-tight text-white lg:text-xl">
          {a.title}
        </h3>
        {a.desc && (
          <p className="mt-2 max-w-md text-xs font-light leading-relaxed text-steel sm:text-sm">
            {a.desc}
          </p>
        )}
      </div>
    </div>
  );
}

export default function Assets({ items }) {
  const list = items || [];
  const gridClass = [
    "h-[340px] lg:col-span-7",
    "h-[340px] lg:col-span-5",
    "h-[320px] lg:col-span-12",
  ];

  return (
    <section
      id="assets"
      data-testid="assets"
      className="border-y border-line bg-surface/60 py-24 lg:py-32"
    >
      <div className="mx-auto max-w-[1400px] px-6 lg:px-12">
        <div className="flex flex-col gap-8 lg:flex-row lg:items-end lg:justify-between">
          <Reveal>
            <Overline>Marine Assets</Overline>
            <h2 className="mt-6 font-display text-4xl font-medium uppercase leading-[0.95] tracking-tighter sm:text-5xl">
              Our own fleet &amp; equipment
            </h2>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="max-w-sm text-sm font-light leading-relaxed text-steel sm:text-base">
              Direct vessel operations from Tanjung Pengelih Terminal — no
              middlemen, no waiting. Just capable hardware, ready around the clock.
            </p>
          </Reveal>
        </div>

        <Reveal delay={0.15} className="mt-12">
          <div className="grid gap-4 lg:grid-cols-12">
            {list.map((a, i) => (
              <AssetCard
                key={a.id || a.title}
                a={a}
                className={gridClass[i] || "h-[320px] lg:col-span-12"}
              />
            ))}
          </div>
        </Reveal>
      </div>
    </section>
  );
}
